export const siteLocationDefaultValues = {};
